import { SkitterPagesResult } from "../../Models/SkitterPagesResult";
import { SkitterbookLivePagesRequest } from '../../Models/SkitterbookLivePagesRequest';
import { authFetch, withSerialisedAsync } from "../../Utils/FetchUtil";

export const SkitterBookPagesApi = {
    LoadAsync: withSerialisedAsync(
        async (skitterBookToken: string): Promise<SkitterPagesResult> => {
            const res = await authFetch(
                `/api/skitterbook/pages?skitterbookToken=${encodeURIComponent(
                    skitterBookToken
                )}`
            );

            if (!res.ok) {
                throw new Error("Failed to load skitterbook pages");
            }

            return res.json();
        },
        "ignore" // or "reject"
    ), LoadLiveAsync: withSerialisedAsync(
        async (request: SkitterbookLivePagesRequest|undefined): Promise<SkitterPagesResult> => {

            const stringRequest = JSON.stringify(request);

            const res = await authFetch(
                `/api/skitterbook/livepages`,
                {
                    method: "POST",
                    body: stringRequest
                }
            );

            if (!res.ok) {
                throw new Error("Failed to load skitterbook pages");
            }

            return res.json();
        },
        "ignore" // or "reject"
    )
};
